import clsx from 'clsx'
import React, { FC, ReactNode, useContext } from 'react'

import { Footer } from '@Components/Footer'
import { Header } from '@Components/Header'
import { MetadataContext } from '@Globals/Metadata'

import styles from './OneColumns.module.scss'

interface OneColumnProps {
  children?: React.ReactNode
  className?: string
  footer?: ReactNode
  header?: ReactNode
}

export const OneColumn: FC<OneColumnProps> = ({
  children,
  className,
  footer,
  header,
}) => {
  const { fonts } = useContext(MetadataContext)

  return (
    <>
      {header || <Header />}
      <main className={clsx(className, styles.oneColumn, fonts)}>{children}</main>
      {footer || <Footer />}
    </>
  )
}
